/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconLever: {
  name: 'lever';
  data: string;
} = {
  name: 'lever',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="m507.923 271.588 84.682-146.674-85.177-49.177-84.682 146.674 15.081 8.707-105.706 183.09a152.169 152.169 0 0 0-26.476-2.314c-82.291 0-149.227 65.731-151.174 147.552h-45.289v41.062h384.94v-41.062h-37.304c-1.193-50.153-26.809-94.253-65.409-120.883l101.43-175.683 15.084 8.708z"/></svg>`,
};
